import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Image,
  Flex,
  SimpleGrid,
  Container,
  Badge,
  HStack,
  VStack,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Center,
} from "@chakra-ui/react";
import { FiCheck, FiArrowRight, FiShield, FiDatabase, FiAward } from "react-icons/fi";
import { apiUrl } from "../ApiUrl/ApiUrl";
import Slider from "react-slick";
import { Link, NavLink } from "react-router-dom";

function Taxman() {
  const [fashion, setFashion] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [itax, setItax] = useState([]);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getFashion = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allbooks`)
      .then((res) => res.json())
      .then((res) => setFashion(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const getPrice2 = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allTaxmanSoftware?Maincatname=software&Author=Taxmann`)
      .then((res) => res.json())
      .then((res) => setItax(res))
      .catch((err) => {
        setError(true);
        console.error("Error fetching Taxmann modules:", err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFashion();
    getPrice2();
  }, []);

  if (loading && itax.length === 0) {
    return (
      <Box minH="80vh" bg="#F8FAFC" py={20}>
        <Center>
          <VStack spacing={4}>
            <Spinner size="xl" color="#162237" thickness="3px" />
            <Text color="gray.600" fontSize="sm">Loading Taxmann Suite...</Text>
          </VStack>
        </Center>
      </Box>
    );
  }

  return (
    <Box bg="#F8FAFC" minH="100vh" pb={16}>
      {/* SaaS Hero Header */}
      <Box
        bgGradient="linear(to-b, #0B132B, #162237)"
        color="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 4, md: 8 }}
        textAlign="center"
      >
        <Container maxW="900px">
          <Badge
            bg="whiteAlpha.200"
            color="#EAB308"
            px={3}
            py={1}
            rounded="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            mb={4}
          >
            ⚖️ TAX & CORPORATE LAWS OF INDIA SINCE 1972
          </Badge>

          <Heading
            as="h1"
            fontSize={{ base: "30px", md: "46px" }}
            fontWeight="extrabold"
            letterSpacing="tight"
            mb={3}
          >
            Taxmann Legal Software & Research
          </Heading>

          <Text
            fontSize={{ base: "sm", md: "lg" }}
            color="gray.300"
            maxW="750px"
            mx="auto"
            lineHeight="tall"
          >
            Pursuing perfection, expertise, and precision in Direct Tax, Indirect Tax (GST), Company Law, SEBI, and Foreign Exchange regulations.
          </Text>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxW="1200px" mt={-8} px={{ base: 3, md: 6 }}>
        <Box
          bg="white"
          rounded="2xl"
          border="1px solid"
          borderColor="gray.200"
          shadow="sm"
          p={{ base: 5, md: 8 }}
        >
          <Flex direction={{ base: "column", lg: "row" }} gap={{ base: 8, lg: 10 }} align="center">
            {/* Left: Overview & Value */}
            <Box w={{ base: "100%", lg: "55%" }}>
              <HStack spacing={2} mb={1}>
                <Text fontSize="xs" fontWeight="bold" color="#EAB308" textTransform="uppercase" letterSpacing="wider">
                  Authoritative Publications
                </Text>
              </HStack>
              <Heading size="lg" color="#162237" fontWeight="bold" mb={4}>
                Direct & Indirect Tax Modules
              </Heading>
              <Text fontSize="xs" color="gray.600" lineHeight="tall" mb={6}>
                Empower your chartered accountancy, corporate tax advisory, or legal practice with real-time statutory circulars, ITAT tribunal decisions, and section-by-section case commentaries.
              </Text>

              {/* Module Table */}
              {itax.length > 0 ? (
                <Box overflowX="auto" rounded="xl" border="1px solid" borderColor="gray.200">
                  <Table variant="simple" size="sm">
                    <Thead bg="#F8FAFC">
                      <Tr>
                        <Th color="gray.600">Module / Subscription</Th>
                        <Th color="gray.600">Price (INR)</Th>
                        <Th color="gray.600" textAlign="right">Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {itax.map((book) => (
                        <Tr key={book.id} _hover={{ bg: "gray.50" }}>
                          <Td fontWeight="medium" color="gray.800" maxW="280px">
                            <Text noOfLines={2}>{book.booktitle}</Text>
                          </Td>
                          <Td fontWeight="bold" color="#162237">₹{book.descprice}</Td>
                          <Td textAlign="right">
                            <Link to={`/products/view/${book.id}`}>
                              <Button size="xs" colorScheme="navy" variant="outline" rounded="md">
                                Buy Access
                              </Button>
                            </Link>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              ) : (
                <Text fontSize="xs" color="gray.500">No active Taxmann modules currently listed.</Text>
              )}
            </Box>

            {/* Right: Product Banner Image */}
            <Box w={{ base: "100%", lg: "45%" }} textAlign="center">
              <Box
                p={4}
                bg="#F1F5F9"
                rounded="2xl"
                border="1px solid"
                borderColor="gray.200"
              >
                <Image
                  src="./taxman.jpeg"
                  alt="Taxmann Logo"
                  maxH="380px"
                  mx="auto"
                  objectFit="contain"
                  rounded="xl"
                  fallbackSrc="https://navneetlawstudio.com/logo.png"
                />
              </Box>
            </Box>
          </Flex>
        </Box>

        {/* Feature Highlights Grid */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mt={8}>
          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="blue.50" color="#162237" align="center" justify="center" mb={3} fontSize="18px">
              <FiDatabase />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              ITAT & High Court Rulings
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Exhaustive reporting of Income Tax Appellate Tribunal benches and constitutional writ petitions.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="purple.50" color="purple.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiAward />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              GST & Customs Analytics
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Advance Rulings (AAR), Appellate Authority decisions (AAAR), notifications, and classification rules.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="green.50" color="green.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiShield />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Verified Editorial Rigor
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Cross-checked with official Gazette notifications and CBDT / CBIC ministerial releases.
            </Text>
          </Box>
        </SimpleGrid>

        {/* Recommended Softwares Slider */}
        <Box mt={12}>
          <Flex justify="space-between" align="center" mb={4}>
            <Box>
              <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wider">
                Explore More Tools
              </Text>
              <Heading size="md" color="#162237">
                Recommended Legal Softwares
              </Heading>
            </Box>
            <Link to="/software">
              <Button size="xs" variant="outline" colorScheme="navy">
                View All Softwares
              </Button>
            </Link>
          </Flex>

          <Box
            p={4}
            bg="white"
            rounded="xl"
            border="1px solid"
            borderColor="gray.200"
            shadow="xs"
          >
            <Slider {...settings}>
              {fashion
                .filter((item) => item.maincatname === "software" || item.subcatname === "software")
                .map((item) => (
                  <Box key={item.id} p={2}>
                    <NavLink to={`/products/view/${item.id}`}>
                      <Box
                        bg="gray.50"
                        rounded="lg"
                        border="1px solid"
                        borderColor="gray.200"
                        p={3}
                        textAlign="center"
                        _hover={{ borderColor: "#162237", bg: "white", shadow: "sm" }}
                        transition="all 0.2s"
                        h="100%"
                      >
                        <Image
                          src={item.imagePath}
                          alt={item.booktitle}
                          h="120px"
                          mx="auto"
                          objectFit="contain"
                          fallbackSrc="https://navneetlawstudio.com/logo.png"
                        />
                        <Text
                          fontSize="xs"
                          fontWeight="bold"
                          color="gray.800"
                          mt={2}
                          noOfLines={2}
                          minH="32px"
                        >
                          {item.booktitle}
                        </Text>
                        <HStack justify="center" spacing={2} mt={1}>
                          <Text fontSize="xs" fontWeight="bold" color="#162237">
                            ₹{item.descprice}
                          </Text>
                          {item.originalprice && (
                            <Text fontSize="10px" color="gray.400" as="del">
                              ₹{item.originalprice}
                            </Text>
                          )}
                        </HStack>
                      </Box>
                    </NavLink>
                  </Box>
                ))}
            </Slider>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Taxman;

